import { render, staticRenderFns } from "./TabTache.vue?vue&type=template&id=49d23754&"
import script from "./TabTache.vue?vue&type=script&lang=js&"
export * from "./TabTache.vue?vue&type=script&lang=js&"
import style0 from "./TabTache.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports